import React, { useEffect, useState } from "react";
import { Button, Container, Input } from "reactstrap";
import { Table, Row, Col, Card, CardBody, CardTitle, CardSubtitle } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { useNavigate, useParams } from "react-router-dom";
import DrugService from "Api/Services/DrugService";
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal";
import Paginations from "common/Paginations";
import UserService from "Api/Services/UserService";
import UserActiveInactive from "components/Common/UserActiveInactive";
import Spinners from "components/Common/Spinner";

import Nouserimage from "../../../assets/images/users/no_image.png";



const UserList = () => {

    //meta title
    document.title = "User List | infuseone - Admin";
    const params = useParams();
    // console.log(params.inactive); 
    const imageUrl = `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}`;
    // Sample data (replace with API call)
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteModal, setDeleteModal] = useState(false);
    // const [lastPage, setLastPage] = useState(1)
    const [totalPage, setTotalPage] = useState()
    const [totalData, setTotalData] = useState()
    const [deleteuserId, setDeleteUserId] = useState();
    const [userToToggle, setUserToToggle] = useState(null);
    const [userActiveInactiveModal, setUserActiveInactiveModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const navigate = useNavigate();
    const [status, setStatus] = useState("");
    const [userStatus, setUserStatus] = useState(false);

    useEffect(() => { 
        if (params.inactive && !userStatus) {
            setStatus('0');
            LoadUserlist(1, "0", globalFilter);
        } else {
            LoadUserlist(1, status, globalFilter);
        }
    }, [status, userStatus, globalFilter]);

    // useEffect(() => { 
    //     if(!params.inactive){
            
    //     }
    // }, [status, globalFilter]);

    const LoadUserlist = async (page, status, search) => {
        setLoading(true);
        try {
            const userData = {
                status: status ? status : "",
                search: search ? search : ""
            }
            const response = await UserService.GetUserList(page, userData).json();
            if (response.status) {
                // SearchUsername(globalFilter);
                setUsers(response.data);
                setCurrentPage(response.meta.current_page);
                setTotalPage(response.meta.last_page);
                setTotalData(response.meta.total);
                setLoading(false);
            } else {
                setLoading(false);
                setError(response.message);
                return;
            }
        } catch (error) {
            setError('Something went wrong');
            return;
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        LoadUserlist(page, status, globalFilter)
    }

    const handleDelete = async (deleteuserId) => {
        setDeleteUserId(deleteuserId)
        setDeleteModal(true);
    };
    const handleDeleteUser = async () => {
        setLoading(true);
        try {
            const response = await UserService.DeleteUser(deleteuserId);

            if (response.status) {
                setSuccess(response.message);
                setUsers(users.filter((user) => user.id !== deleteuserId));
                LoadUserlist(1, status, globalFilter);
                setDeleteModal(false);
                setLoading(false);
            } else {
                setError(response.message);
            }
        } catch (error) {
            setError('Something went wrong while deleting the user');
        }

    };

    const handleUpdate = async (userId) => {
        navigate(`/user-edit/${userId}`);
    };
    const handleAssigneDrugs = async (userId) => {
        navigate(`/assigne-drug/${userId}`);
    };


    const handleUserActiveInactive = (user) => {
        setUserToToggle(user);
        setUserActiveInactiveModal(true);
    };
    const handleActiveInactiveUser = async () => {
        if (!userToToggle) return;
        setLoading(true);
        try {
            const response = await UserService.ChangeUserStatus(userToToggle.id);
            if (response.status) {
                setUsers(users.map(user =>
                    user.id === userToToggle.id ? { ...user, is_active: !userToToggle.is_active } : user
                ));
                setSuccess(response.message);
                setUserActiveInactiveModal(false);
                LoadUserlist(currentPage, status, globalFilter);
                setLoading(false);
            } else {
                setError(response.message);
            }
        } catch (error) {
            console.error(error);
            setError('Something went wrong while updating the user status.');
        } finally {
            setUserActiveInactiveModal(false);
            setUserToToggle(null);
        };
    }

    const handleStatusChange = (event) => {
        const newStatus = event.target.value;
        // if (newStatus) {
        //     navigate("/user-list");
        // }
        setStatus(newStatus);
        setUserStatus(true);
        LoadUserlist(1, newStatus, globalFilter);
    };


    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteUser}
                onCloseClick={() => setDeleteModal(false)}
            />
            {/* {isLoading ? <Spinners setLoading={setLoading} /> : */}
            <UserActiveInactive
                show={userActiveInactiveModal}
                onChangeClick={() => handleActiveInactiveUser()}
                onCloseClick={() => setUserActiveInactiveModal(false)}
                isActive={userToToggle ? userToToggle?.is_active : false}
                modelType="user"
            />
            {/* } */}
            <div className="page-content">
                <Container fluid>
                    <div className="container-fluid">
                        <Breadcrumbs title="Dashboard" breadcrumbItem="User List" />
                        <Row>
                            <Col lg={12}>
                                <Card className={isLoading ? "commonboxform pb-5" : "commonboxform"}>
                                    <CardBody>
                                        <div className='d-flex justify-content-between  align-items-center'>
                                            {/* <CardTitle className="h4">User List </CardTitle> */}
                                            <div className="app-search  p-0 d-flex gap-3">
                                                <div className="position-relative">
                                                    <Input type="text" name="search" className="form-control search-box px-3" placeholder="Search..." value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} />
                                                    {/* <span className="bx bx-search-alt clssearchicon font-size-20" onClick={() => SearchUsername()} ></span> */}
                                                </div>
                                                <div className="col-sm-auto">
                                                    <label className="visually-hidden" htmlFor="autoSizingSelect">Preference</label>
                                                    <select className="form-select" name="status" value={status} onChange={(e) => handleStatusChange(e)}>
                                                        <option value="">Filter Status...</option>
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <Link to="/user-add" className='btn btn-secondary btn-rounded'><i className="mdi mdi-plus"></i>Add New User</Link>

                                        </div>

                                        <div className="table-responsive">

                                            <Table className="table mb-0">
                                                <thead>
                                                    <tr className="text-center">
                                                        <th>No</th>
                                                        <th>Profile Image</th>
                                                        <th>Username</th>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th>Phone Number</th>
                                                        <th>Status</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="relativecls">

                                                    {isLoading ? <Spinners setLoading={setLoading} /> :
                                                        <>
                                                            {users.map((users, index) => (
                                                                <tr key={users.id} className="text-center">
                                                                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                                                                    <td className="d-flex justify-content-center">
                                                                        <div className="avatar-sm bg-light rounded p-2">
                                                                            <img src={users.profile_image ? `${imageUrl}/${users.profile_image}` : Nouserimage} alt={users.name} className="img-fluid rounded-circle" />
                                                                        </div>
                                                                    </td>
                                                                    <td>{users.username ? users.username : '-'}</td>
                                                                    <td>{users.name}</td>
                                                                    <td>{users.email}</td>
                                                                    <td>{users.phone_number}</td>
                                                                    <td >
                                                                        <a className="px-4 text-center" onClick={() => handleUserActiveInactive(users)}>
                                                                            {users.is_active && users.is_active == 1 ?
                                                                                <span className="bg-success badge bg-secondary w-50 fs-6" >Active </span>
                                                                                : <span className="bg-danger badge bg-secondary w-50 fs-6" >Inactive</span>
                                                                            }
                                                                        </a>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex gap-3 justify-content-center align-items-baseline">
                                                                            <a className="text-success" onClick={() => handleUpdate(users.id)}>
                                                                                <i className="mdi mdi-pencil font-size-18" id="edittooltip" title="Edit"></i>
                                                                            </a>
                                                                            <a className="text-info" onClick={() => handleAssigneDrugs(users.id)} >

                                                                                <i className="bx bxs-capsule font-size-18" id="deletetooltip" title="Assign Drug"></i>
                                                                            </a>
                                                                            <a className="text-danger" onClick={() => handleDelete(users.id)} >
                                                                                <i className="mdi mdi-delete font-size-18" id="deletetooltip" title="Delete"></i>
                                                                            </a>

                                                                        </div>

                                                                    </td>
                                                                </tr>
                                                            ))
                                                            }
                                                        </>
                                                    }
                                                </tbody>
                                            </Table>
                                            <h5 className="text-center mt-4">
                                                {users.length == 0 && !isLoading ? 'Data Not Found!' : ''}
                                            </h5>
                                            {users.length != 0 && !isLoading ?
                                                <Paginations
                                                    currentPage={currentPage}
                                                    totalPages={totalPage}
                                                    onPageChange={handlePageChange}
                                                />
                                                : ''}

                                        </div>

                                    </CardBody>
                                </Card>
                            </Col>

                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UserList;